var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHomeActive = function SvgHomeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#273F3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17h6m2 4H7a4 4 0 0 1-4-4v-6.292a4 4 0 0 1 1.927-3.42l5-3.03a4 4 0 0 1 4.146 0l5 3.03A4 4 0 0 1 21 10.707V17a4 4 0 0 1-4 4Z",
    stroke: "#273F3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgHomeActive as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iOSIgeT0iOSIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjEiIGZpbGw9IiMyNzNGM0IiLz4KPHBhdGggZD0iTTkgMTcuMDAwMUgxNU0xNyAyMS4wMDAxSDdDNS45MzkxMyAyMS4wMDAxIDQuOTIxNzIgMjAuNTc4NiA0LjE3MTU3IDE5LjgyODVDMy40MjE0MyAxOS4wNzgzIDMgMTguMDYwOSAzIDE3LjAwMDFWMTAuNzA4MUMyLjk5OTk5IDEwLjAyMDMgMy4xNzczMiA5LjM0NDExIDMuNTE0ODcgOC43NDQ4NUMzLjg1MjQyIDguMTQ1NiA0LjMzODc5IDcuNjQzNTEgNC45MjcgNy4yODcwNkw5LjkyNyA0LjI1NzA2QzEwLjU1MjEgMy44NzgyNiAxMS4yNjkxIDMuNjc3OTggMTIgMy42Nzc5OEMxMi43MzA5IDMuNjc3OTggMTMuNDQ3OSAzLjg3ODI2IDE0LjA3MyA0LjI1NzA2TDE5LjA3MyA3LjI4NzA2QzE5LjY2MTEgNy42NDM0MiAyMC4xNDczIDguMTQ1MzUgMjAuNDg0OSA4Ljc0NDQyQzIwLjgyMjQgOS4zNDM0OCAyMC45OTk4IDEwLjAxOTQgMjEgMTAuNzA3MVYxNy4wMDAxQzIxIDE4LjA2MDkgMjAuNTc4NiAxOS4wNzgzIDE5LjgyODQgMTkuODI4NUMxOS4wNzgzIDIwLjU3ODYgMTguMDYwOSAyMS4wMDAxIDE3IDIxLjAwMDFaIiBzdHJva2U9IiMyNzNGM0IiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";